export default "__VITE_ASSET__BWEdzh4S__"